import { connect } from "react-redux";
import SurveyStepPeriode from "./SurveyStepPeriode";
//import { surveySelector } from "./../../../../redux/selectors"
import { addStepSurvey } from "./../../../../redux/actions/surveyActions";
import { storeSurveyProgress } from "./../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		//currentSurvey: surveySelector(state, ownProps),
		surveyProgress: state.survey.surveyManager.surveyProgress,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		storeSurveyProgress: () => {
			dispatch(storeSurveyProgress());
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SurveyStepPeriode);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepPeriode/SurveyStepPeriodeContainer.js